import { baseApi } from '../base.js'
import qs from 'qs'

const firmApi = baseApi.injectEndpoints({
  endpoints: build => ({
    getFirms: build.query({
      query: params => {
        const queryParams = qs.stringify(params)

        return `/firms/v2/search?${queryParams}`
      },
    }),
    getFirm: build.query({
      query: firmId => `/firms/${firmId}`,
    }),
    getFirmSettings: build.query({
      query: firmId => `/firms/${firmId}/settings`,
      transformResponse: response => response.firmSettings,
    }),
  }),
  overrideExisting: false,
})

export const { useGetFirmsQuery, useGetFirmQuery, useGetFirmSettingsQuery } =
  firmApi

export { firmApi }
